/* eslint-disable import/prefer-default-export */

import styled from 'styled-components';
import { layout, media } from 'src/components/base';
import { zindex } from 'src/ui/zindex';

export const NudgedBox = styled.div`
  height: calc(100vh - ${layout.headerHeight.desktop.rem});
  top: ${layout.headerHeight.desktop.rem};
  position: fixed;
  width: 100%;
  /* Should be above sidebar */
  z-index: ${zindex.menu.mega};
`;

export const Navigation = styled.nav`
  max-width: 1250px;
  margin-left: auto;
  margin-right: auto;

  ul {
    margin: 0;
    list-style-type: none;
  }
`;

export const NavigationWrapper = styled.div`
  flex: 0 0 100%;
  position: fixed;
  background: ${({ theme }) => theme.bg.primary};
  width: 100%;
  max-height: 80vh;
  overflow: hidden;
  z-index: ${zindex.menu.mega + 1};

  ${media.mediumDown`
    display: none;
  `};
`;

export const Overlay = styled.div`
  flex: 0 0 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${p => p.theme.bg.overlay};
  opacity: 0.9;

  transition: opacity 0.1s ease;
  visibility: visible;
  position: fixed;
  z-index: 9;
`;
